import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs'
import { environment } from '@/environments/environment';
import { ApiResponse } from '@core/models/api-response.model';
import { User } from '@core/models/user.model';
import { alertNotification } from "@/app/utils/util"

@Injectable({ providedIn: 'root' })
export class UserService {
  private apiUrl = `${environment.apiUrl}/users`;

  constructor(private http: HttpClient) {}

  getAll(request: any): Observable<ApiResponse<User[]>> {
    return this.http.post<ApiResponse<User[]>>(`${this.apiUrl}/list`, request);
  }

  getByUuid(uuid: string): Observable<ApiResponse<User>> {
    return this.http.get<ApiResponse<User>>(`${this.apiUrl}/${uuid}`);
  }

  create(user: Partial<User>): Observable<ApiResponse<User>> {
    return this.http.post<ApiResponse<User>>(`${this.apiUrl}/store`, user);
  }

  update(user: Partial<User>): Observable<ApiResponse<User>> {
    return this.http.post<ApiResponse<User>>(`${this.apiUrl}/update`, user);
  }

  delete(user: Partial<User>): Observable<ApiResponse<null>> {
    return this.http.post<ApiResponse<null>>(`${this.apiUrl}/delete`, user);
  }
  changePassword(data:object){
   return this.http.post<ApiResponse<any>>(`${this.apiUrl}/change_password`, data).pipe(
       map(response => {
         if(response.status === 'success'){
           return response;
         }
         alertNotification(response.message,'error')
         throw response;
       })
   );
  }
}
